import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl } from '../common/base-list.component';
import { EventService } from '../common/service/event.service';
import { ServiceLocatorService } from '../common/service/service-locator.service';
import { NgForm } from '@angular/forms';
import { GlobalConstants } from '../common/GlobalConstants ';

@Component({
  selector: 'app-visitor-mangement-list',
  templateUrl: './visitor-mangement-list.component.html',
  styleUrls: ['./visitor-mangement-list.component.css']
})
export class VisitorMangementListComponent extends BaseListCtl {

  userContext = JSON.parse(localStorage.getItem(GlobalConstants.getKey('userContext')));
  authKey=JSON.parse(localStorage.getItem(GlobalConstants.getKey('skey')));

  constructor(public locator: ServiceLocatorService, public route: ActivatedRoute,private eService: EventService) {
    super(locator.endpoints.VISITORMANAGEMENT,locator,route);
  }

  populateForm(form, data) {
    super.populateForm(form, data);
    form.id = data.id;
    form.firstName = data.firstName;
    form.lastName = data.lastName;
    form.address= data.address ; 
    form.mobile= data.mobile ; 
    form.loginId= data.loginId ;
    form.password= data.password ;
    form.role= data.role ;
    form.userName= data.userName ; 
    form.mobileId= data.mobileId ;  
    form.userId = data.userId;
    form.status = data.status;
    form.orgId = data.orgId 
    form.appId = data.appId 
    console.log('----->',data);
  }


  isLogin = false;

  saveOrupdateVis(){
    var _self = this;
    _self.form.data['login'] = _self.form.data['loginId']
    if(_self.form.data.id>0)
    {
      _self.updateVis();
    }
    else{
      _self.signUpVis();
    }
  
  }

  updateVis() {

    var _self = this;
    if(_self.userContext.orgId == 22)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.NCS_ORGID;
    }
    if(_self.userContext.orgId == 73)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.POWERTECH_ORGID;
    }
    if(_self.userContext.orgId == 66)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.RAYS_ORGID;
    }
    if(_self.userContext.orgId == 74)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.MnM_Group_Of_Companies;
    }
    if(_self.userContext.orgId == 85)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.CreatEV_Solutions ;
    }
    _self.form.data["appId"] = _self.locator.endpoints.PNAC_APPID;   
    _self.form.data["orgName"] = _self.userContext.orgName;

    _self.form.data["role"] = "Visitor"
    let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.VISITORMANAGEMENT, "/updateVis/"+ _self.authKey);
    _self.locator.http.post(url, _self.form.data, function (res, error) {

    _self.form.message = '';
    _self.form.inputerror = {};

      if(res.success){
        _self.isLogin = true;
      }
      _self.form.error = res.success;
      _self.form.message = 'Updated Successfully';
      _self.search();
      _self.form.inputerror = res.result.inputerror;
    });
  }

  signUpVis() {

    var _self = this;
    if(_self.userContext.orgId == 22)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.NCS_ORGID;
    }
    if(_self.userContext.orgId == 73)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.POWERTECH_ORGID;
    }
    if(_self.userContext.orgId == 66)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.RAYS_ORGID;
    }
    if(_self.userContext.orgId == 74)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.MnM_Group_Of_Companies;
    }
    if(_self.userContext.orgId == 85)
    {
      _self.form.data["orgId"] = _self.locator.endpoints.CreatEV_Solutions ;
    }
    _self.form.data["appId"] = _self.locator.endpoints.PNAC_APPID;   
    _self.form.data["orgName"] = _self.userContext.orgName;

    _self.form.data["role"] = "Visitor"
    let url = this.locator.endpoints.getEndpoint(this.locator.endpoints.VISITORMANAGEMENT, "/signUpVis");
    _self.locator.http.post(url, _self.form.data, function (res, error) {

      _self.form.message = '';
      _self.form.inputerror = {};

      //console.log("1");
      if(res.success){
        _self.isLogin = true;
        _self.search();
      }
      _self.form.error = !res.success;
      _self.form.message = res.result.message;
      _self.form.inputerror = res.result.inputerror;
    });
  }
  title = 'MobileNumberValidation';  
  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";  
 isValidFormSubmitted = false;  
 
 onFormSubmit(form: NgForm) {  
   this.isValidFormSubmitted = false;  
   if (form.invalid) {  
      return;  
   }  
   this.isValidFormSubmitted = true;  
   form.resetForm();  
 }
 emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";  
  
 iseValidFormSubmitted = false;  
   oneFormSubmit(form: NgForm) {  
   this.iseValidFormSubmitted = false;  
   if (form.invalid) {  
      return;  
   }
   this.iseValidFormSubmitted = true;  
   form.resetForm();  
}  
}
